import Query from "@arcgis/core/rest/support/Query";

const statDefinitions = [
    {
        onStatisticField: "hws",
        outStatisticFieldName: "hws_sum",
        statisticType: "sum",
    }, {
        onStatisticField: "tagbev",
        outStatisticFieldName: "tagbev_sum",
        statisticType: "sum",
    }
]

function queryStatistic(layer, queryGeometry){
    const query = layer.createQuery();
    query.geometry = queryGeometry;
    query.outStatistics = statDefinitions;

    return layer.queryFeatures(query).then((res) => {
        return res.features[0].attributes;
    })
}

function queryFeatureCount(layer, queryGeometry, poiType) {
    const query = new Query();
    query.geometry = queryGeometry;
    query.spatialRelationship = "intersects";

    // return the feature count from the layer
    return layer.queryFeatureCount(query).then((res)=>{
        return { [poiType]: res }
    })
}

export { queryStatistic, queryFeatureCount };
